import { parse } from 'graphql'

export const LEGACY_PROGRAM_FRAGMENT = parse(`
  fragment LegacyProgramFragment on Program {
    id
    layoutName
    locale
    pricingTransparency
    provider {
      description
      name
      id
    }
    theme
    ... on ProgramTiles {
      title
      pricingTransparency
      tiles {
        image
        subtitle
        title
        program {
          layoutName
          id
          ... on BookingFlow {
            activity {
              id
              name
              description
              imageUrls
              type
            }
          }
        }
      }
    }
    ... on BookingFlow {
      orderTaxesFeesBreakdownMode
      activity {
        id
        name
        description
        imageUrls
        type
        tickets {
          id
          name
          description
          imageUrl
        }
      }
      promoCodeDisplay
      promoCodeLocation
    }
  }
`)
